import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260125_add_tags_to_entities",
  description: "Add tags field to ComponentInstance, StaticRoom, Roof, and FloorSystem",
  apply(json: any): any {
    // Add tags to component instances
    const componentInstances = json.componentInstances ?? {};
    for (const id of Object.keys(componentInstances)) {
      if (!componentInstances[id].tags) {
        componentInstances[id].tags = {};
      }
    }

    // Add tags to rooms
    const rooms = json.rooms ?? {};
    for (const id of Object.keys(rooms)) {
      if (!rooms[id].tags) {
        rooms[id].tags = {};
      }
    }

    // Add tags to roofs
    const roofs = json.roofs ?? {};
    for (const id of Object.keys(roofs)) {
      if (!roofs[id].tags) {
        roofs[id].tags = {};
      }
    }

    // Add tags to floor systems
    const floorSystems = json.floorSystems ?? {};
    for (const id of Object.keys(floorSystems)) {
      if (!floorSystems[id].tags) {
        floorSystems[id].tags = {};
      }
    }

    return json;
  },
};

export default migration;
